import { ConfigProvider, App } from 'antd';
import enUS from 'antd/lib/locale/en_US';
import React from 'react';

interface AntdConfigProviderProps {
  children: React.ReactNode
}

export const COLOR_PRIMARY = '#00ADB9';
export const COLOR_PRIMARY_HOVER = '#009DA8';

export default function AntdConfigProvider({ children }: AntdConfigProviderProps): React.ReactNode {
  return (
    <ConfigProvider
      locale={enUS}
      theme={{
        token: {
          colorPrimary: COLOR_PRIMARY,
          colorLink: COLOR_PRIMARY,
          colorLinkHover: COLOR_PRIMARY_HOVER,
          colorLinkActive: COLOR_PRIMARY,
          fontFamily: '\'DM Sans\', sans-serif',
        },
      }}
    >
      <App>
        {children}
      </App>
    </ConfigProvider>
  );
}
